export class StringConstants {
  PROD = false;

  //Firebase
  FIREBASE_VAPID_KEY =
    "BOl9M96dD8Ba71zyz6jtxEkpPMYgyuUJV9jxzPcwlstYC3QGBzLTV4DJJkUCXl_n0vFyFSOi9IoIRA2ptWfWc90";
  firebase_apiKey = "AIzaSyDQFgqVotfqgZqk1OnILgGYyI0KiA0aTBg";
  firebase_authDomain = "healthcaresages.firebaseapp.com";
  firebase_projectId = "healthcaresages";
  firebase_storageBucket = "healthcaresages.appspot.com";
  firebase_messagingSenderId = "248661924179";
  firebase_appId = "1:248661924179:web:92287c0464d7e50c3069a6";
  firebase_measurementId = "G-BK8QKBREDQ";

  //contentTypes
  applicationJSON = { "Content-Type": "application/json" };
  fileJSON = { "Content-Type": "text/csv" };
  multipartForm = {};

  notification = "notification";
  web = "web";
  error = "error";
  success = "success";
  warning = "warning";
  info = "info";
  autoHideDuration = 600 * 1000; //in milliseconds

  //date
  am = "AM";
  pm = "PM";

  //tabs value
  active = "Active";
  roleManagement = "Role Management";
  security = "Security";
  onboarding = "Onboarding";
  underReview = "UnderReview";
  preferences = "Preferences";
  blacklist = "Blacklist";
  generated = "Generated";
  sent = "Sent";
  paid = "Paid";
  overdue = "Overdue";
  due = "Due";
  partiallyPaid = "PartiallyPaid";
  Account = "Account";
  Location = "Location";
  open = "Open";
  complete = "Complete";
  inProcess = "InProcess";

  //NOTIFICATION
  notifications = "Notifications";
  markAsRead = "Mark as Read";
  deleteAll = "Delete All";

  //buttons
  delete = "Delete";
  inactivate = "Inactivate";
  reactivate = "Reactivate";
  createRole = "Create Role";

  //Job posting - Type
  string = "String";

  // Regex
  EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/;

  //Email validation Regex
  regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  regexPassword =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,100}$/;
  //Phone Number Regex
  phoneNumber = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

  // GroupNameRegex
  groupNameRegex = /^[a-zA-Z0-9 _\-\(\)]*$/;

  // Only Characters Regex
  characterRegex = /^[A-Za-z ]*$/;
  // Time-Out
  SEARCH_TIME_OUT = 1000;

  //component name Pages
  SETTINGS = "Settings";
  DASHBOARD = "Dashboard";

  //Contacts
  CONTACTS = "Contacts";
  GROUPS = "Groups";
  TAGS = "Tags";

  //Campaigns
  CAMPAIGNS = "Campaigns";
  EMAILS = "Emails";
  SOCIAL = "Socials";

  // Integrations
  isFacebookReleased = true;
  isLinkedinReleased = false;
  isInstagramReleased = true;
  isWhatsappReleased = true;
  isSalesforceReleased = true;
  META = "Meta";
  FACEBOOK = "Facebook";
  LINKEDIN = "LinkedIn";
  INSTAGRAM = "Instagram";
  WHATSAPP = "WhatsApp";
  SALESFORCE = "Salesforce";
  INTEGRATION = false;
  instagramBusinessAccountKey = "instagram_business_account";
  All = "All";
  Completed = "Completed";
  Submitted = "Submitted";

  STATE = "123456789";
  FACEBOOK_APP_ID = 1347418019080617;
  FACEBOOK_APP_SECRET = "f474dc2284358fc1a8fdd73955d2fa81";
  CUSTOM_API_TIMEOUT_LIMIT = 40000;

  TEMPLATES = "Templates";
  INTEGRATIONS = "Integrations";
  REPORTS = "Reports";
  RECIPIENT_DOMAINS = "Recipient Domains";
  FAILED_STATS = "Failed Stats";

  //Segment Types
  SEGMENT_GROUP = 1;
  SEGMENT_TAG = 2;

  //for settings
  domainsList = "Domains List";
  domainDetails = "Domain Details";

  DOMAIN_NAME_LIMIT = 63;
  SENDER_NAME_LIMIT = 40;
  TEST_MAIL_LIMIT = 9;
  TAGS_LIMIT = 25;

  //Email Domain
  EmailDomainStatus = {
    Active: "Active",
    CNAMEPending: "CNAMEPending",
    VerificationPending: "VerificationPending",
  };

  EmailDomainStatusDisplayValue = {
    Active: "Active",
    CNAMEPending: "CNAME Pending",
    VerificationPending: "Verification Pending",
  } as { [key: string]: string };

  UploadContactsSteps = {
    CsvConfirmed: "CsvConfirmed",
    DataMapped: "DataMapped",
    NameSelected: "NameSelected",
  };

  // ReCAPTCHA
  RECAPTCHA_SITE_KEY = "6Lc6hiAqAAAAABUxVff-zC2KBqRtoi-tH_Q8_0oY";

  PLACES_API_KEY = "AIzaSyCrHSvGIrvAphzJJKazMNiGNUnZMB98IWc";
  //Payment plan
  FREE_PLAN_ID = "089cc9f7f4de4023a870717f52364f63";

  //file types
  jpeg = ".jpeg";
  JPEG = ".JPEG";
  JPG = ".JPG";
  jpg = ".jpg";
  png = ".png";
  PNG = ".PNG";
  gif = ".gif";
  bmp = ".bmp";
  tiff = ".tiff";
  pdf = ".pdf";
  PDF = ".PDF";
  doc = ".doc";
  docx = ".docx";
  txt = ".txt";
  xls = ".xls";
  xlsx = ".xlsx";
  csv = ".csv";
  FileUrlPrefix = `https://view.officeapps.live.com/op/embed.aspx?src=`;

  // Resources
  app = "app";
  account = "account";
  document = "document";
  campaigner = "campaigner";
  campaign = "campaign";
  healthWorker = "healthWorker";
  healthClient = "healthClient";
  contact = "contact";
  social = "social";
  RecipientDomains = "RecipientDomains";
  billing = "billing";

  // Permissions
  adminPermission = "admin";
  selfPermission = "self";
  fetchPermission = "fetch";
  addPermission = "add";
  updatePermission = "update";
  uploadPermission = "upload";
  deletePermission = "delete";

  allTemplates = "All Templates";
  myTemplates = "My Templates";

  rolesTable = "Roles";
  editRole = "Edit Role";

  //date range intervals
  currentWeek = "Current Week";
  previousWeek = "Previous Week";
  lastSevenDays = "Last 7 Days";
  currentMonth = "Current Month";
  previousMonth = "Previous Month";
  allTime = "All time";
  lastThirtyDays = "Last 30 Days";

  DATE_RANGE_FILTERS = [
    this.currentWeek,
    this.previousWeek,
    this.lastSevenDays,
    this.currentMonth,
    this.previousMonth,
    this.lastThirtyDays,
    this.allTime,
  ];

  MAILZZY_DOMAINS = [
    "mailzzy.com",
    "trywithmailzzy.com",
    "sendwithmailzzy.com",
  ];

  //Unlayer
  UNLAYER_PROJECT_ID = 33804;

  WEBSITE_DESCRIPTION_SIZE = 200;
  ANSWER_SIZE = 50;

  pendingVerificationErrorMessage =
    "Account verification is pending. Please check your email to complete the activation";

  passwordValidationRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[#@$!%*?&])(?=.*[0-9])[A-Za-z\d#@$!%*?&]{8,}/;

  // Custom Domain Regex
  domainNameRegex = /^(?!-)[a-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/;
  // REgex for email's local part
  localPartRegex = /^[a-zA-Z0-9._%+-]+$/i;

  // Text formatting
  bold = "bold";
  italic = "italic";
  strikethrough = "strikethrough";
  boldMarkdownSymbol = "*";
  italicMarkdownSymbol = "_";
  strikethroughMarkdownSymbol = "~";

  //For Support Ticket
  assignedToMe = "Assigned To Me";
  raisedByMe = "Raised By Me";
  completedTickets = "Completed Tickets";
  openTickets = "Open Tickets";
  PROCESSADMIN = "Process Admin";
  USER_DESCRIPTION_LIMIT = 500;
  TICKET_USER_TITLE_LIMIT = 50;
  ABTestWaiting = "ABTestWaiting";

  ALLOWED_RESUME_TYPE = [
    this.jpeg,
    this.gif,
    this.jpg,
    this.pdf,
    this.png,
    this.JPEG,
    this.JPG,
    this.PDF,
    this.PNG,
    this.txt,
  ];

  CLARITY_PROJECT_ID = "p5hnbpvuv0";
}

let strings = new StringConstants();
export default strings;
